<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'UserAuthorization'
}

</script>



// WEBPACK FOOTER //
// src/Adm/UserAuthorization/containers/UserAuthorization.vue